import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import { formatRegistrationDate } from '../../../../../components/common/time/timeHelper'


const CheckLawSuitsPerson = ({ lawsuitsPersonCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = lawsuitsPersonCheck?.checkDetails
  const found = lawsuitsPersonCheck?.found

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography><Typography>{t('common:lawsuits')} {t('common:persons')}</Typography></Typography>
      </Paper>

      <CheckDetailTitle
        email={lawsuitsPersonCheck?.email}
        status={lawsuitsPersonCheck?.status}
        createdAt={lawsuitsPersonCheck?.createdAt}
        updatedAt={lawsuitsPersonCheck?.updatedAt}
      />

      {found ? (
        <TimelineDotLine>
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <Paper elevation={0} variant="rootOutlined" sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 2 }}>{t('common:overview', 'Resumen')}</Typography>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:totalLawsuits', 'Total Juicios')}</Typography>
                  <Typography variant="subtitle3">{details?.TotalLawsuits ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:asAuthor', 'Como Autor')}</Typography>
                  <Typography variant="subtitle3">{details?.TotalLawsuitsAsAuthor ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:asDefendant', 'Como Demandado')}</Typography>
                  <Typography variant="subtitle3">{details?.TotalLawsuitsAsDefendant ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:asOther', 'Otros')}</Typography>
                  <Typography variant="subtitle3">{details?.TotalLawsuitsAsOther ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:firstLawsuitDate')}</Typography>
                <Typography variant="subtitle3">
                  {details.FirstLawsuitDate && formatRegistrationDate(details.FirstLawsuitDate).endsWith('1901')
                    ? '---'
                    : formatRegistrationDate(details.FirstLawsuitDate)}
                </Typography>
              </div>
                 <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:lastLawsuitDate')}</Typography>
                <Typography variant="subtitle3">{formatRegistrationDate(details.LastLawsuitDate).endsWith('9999')
                    ? '---'
                    : formatRegistrationDate(details.LastLawsuitDate)}</Typography>
              </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:last30', 'Juicios últimos 30 días')}</Typography>
                  <Typography variant="subtitle3">{details?.Last30DaysLawsuits ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:last90', 'Juicios últimos 90 días')}</Typography>
                  <Typography variant="subtitle3">{details?.Last90DaysLawsuits ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:last180', 'Juicios últimos 180 días')}</Typography>
                  <Typography variant="subtitle3">{details?.Last180DaysLawsuits ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:last365', 'Juicios últimos 365 días')}</Typography>
                  <Typography variant="subtitle3">{details?.Last365DaysLawsuits ?? '---'}</Typography>
                </div>
              </div>         
            </Paper>
          </div>
        </TimelineDotLine>
      ) : (
        details?.informação ? (
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <Typography variant="subtitle1">{t('common:data')}</Typography>
            <Typography variant="subtitle3">{details?.informação}</Typography>
          </Paper>
        ) : (
          <Paper variant="rootOutlined" elevation={0}>
            <Typography variant="subtitle3">{t('common:noDataFound', 'No se encontraron datos.')}</Typography>
          </Paper>
        )
      )
      }
    </>
  )
}

export default CheckLawSuitsPerson

  